<template>
  <div class="container">
    <button class="button is-primary is-small is-pulled-right" @click="add">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>
      <span>Cadastrar</span>
    </button>
    <br><br>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Cadastrar</p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form v-if="!mostraCompartilhamento && !mostraEmails && !mostraImages">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field is-fullwidth">
                  <input class="input" type="text" placeholder="Informe a descrição do perfil" v-model="perfil.descricao">
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Estado</label>
              </div>
              <div class="field-body">
                <div class="select is-fullwidth">
                  <select v-model="perfil.estado" @change="selectEstado">
                    <option value="0" disabled>Selecione um estado</option>
                    <option v-for="uf in estados" :key="uf.sigla" :value="uf.sigla">
                      {{ uf.sigla }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Cidade</label>
              </div>
              <div class="field-body">
                <div class="select is-fullwidth">
                  <select v-model="perfil.cidade">
                    <option value="0" disabled>Selecione uma cidade</option>
                    <option v-for="cidade in cidades" :key="cidade.id" :value="cidade">
                      {{ cidade.nome }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Versão</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="perfil.versao_plano_contas">
                        <option v-for="versao_plano_contas in versoesPlanosContas" :key="versao_plano_contas.id" :value="versao_plano_contas">
                            {{versao_plano_contas.descricao}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraCompartilhamento">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Usuário</label>
              </div>
              <div class="field-body">
                <div class="field is-full">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="usuarioPerfil.usuario">
                        <option v-for="usuario in usuarios" :key="usuario.id" :value="usuario">
                          {{ usuario.username }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraEmails">
            <div class="field is-horizontal">
              <div class="field-label is-fullwidth">
                <label class="label">Nome</label>
              </div>
              <div class="field-body">
                <div class="field is-fullwidth">
                  <input class="input" type="text" placeholder="Informe o nome" v-model="perfilEmail.nome">
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-fullwidth">
                <label class="label">Email</label>
              </div>
              <div class="field-body">
                <div class="field is-fullwidth">
                  <input class="input" type="email" placeholder="Informe o email" v-model="perfilEmail.email">
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Tipo de Relatório</label>
              </div>
              <div class="field-body">
                <div class="field is-normal">
                  <div class="select is-fullwidth">
                    <select v-model="perfilEmail.tipo_envio_relatorio">
                      <option value="0">Todos</option>
                      <option value="1">PDF</option>
                      <option value="2">Excel</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraImages">
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Destino</label>
              </div>
              <div class="field-body">
                <div class="field is-normal">
                  <div class="select is-fullwidth">
                    <select v-model="perfilImagem.tipo_destino_imagem">
                      <option value="1">Cabeçalho</option>
                      <option value="2">Rodapé</option>
                      <option value="3">Logomarca</option>
                      <option value="4">Capa do Relatório</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <input class="file-input" type="file" ref="file" @change="uploadImageFile">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Selecione a imagem
                  </span>
                </span>
                <span class="file-name">
                  {{ arquivoImagem || 'Nenhuma imagem selecionada' }}
                </span>
              </label>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">Salvar</button>
          <button class="button" v-on:click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns" v-show="showInfo">
      <div class="column is-6">
        <div class="card">
          <header class="card-header has-background-primary">
            <p class="card-header-title has-text-white">Perfis</p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Descrição</th>
                    <th class="has-text-centered">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(perfil, index) in perfis" :key="perfil.id">
                    <td>{{ perfil.descricao }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" :disabled="mostraCompartilhamento || mostraEmails || mostraImages" title="Editar perfil">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" :disabled="mostraCompartilhamento || mostraEmails || mostraImages" title="Excluir perfil">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-primary is-outlined" @click="callCompartilhamento(perfil)" :disabled="mostraCompartilhamento || mostraEmails || mostraImages" title="Compartilhar perfil">
                          <span class="icon is-small">
                            <i class="fas fa-share-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-success is-outlined" @click="callImages(perfil)" :disabled="mostraCompartilhamento || mostraEmails || mostraImages" title="Imagens do perfil">
                          <span class="icon is-small">
                            <i class="fas fa-image"></i>
                          </span>
                        </button>
                        <button class="button is-small is-warning is-outlined" @click="callEmails(perfil)" :disabled="mostraCompartilhamento || mostraEmails || mostraImages" title="E-mails do perfil">
                          <span class="icon is-small">
                            <i class="fas fa-at"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="column" v-show="mostraCompartilhamento">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Compartilhamento do Perfil {{ perfilSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraCompartilhamento = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Usuários</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(usuarioPerfil, index) in usuariosPerfil" :key="usuarioPerfil.id">
                    <td>{{ usuarioPerfil.usuario.username }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraCompartilhamento = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>

      <div class="column" v-show="mostraEmails">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Emails do Perfil {{ perfilSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraEmails = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Email</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pe, index) in perfilEmails" :key="pe.id">
                    <td>{{ pe.nome }}</td>
                    <td>{{ pe.email }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraEmails = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>

      <div class="column" v-show="mostraImages">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Imagens do Perfil {{ perfilSelecionado.descricao }}</p>
            <a class="card-header-icon" @click="mostraImages = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Destino</th>
                    <th>Imagem</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pi, index) in perfilImagens" :key="pi.id">
                    <td>{{ destinoImagemLabels[pi.tipo_destino_imagem] }}</td>
                    <td><figure class="image is-64x64"><img :src="pi.imagem" alt="Imagem do perfil" /></figure></td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraImages = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import _ from 'lodash'
    import {http} from '../../services/config'
    import {httpPublic} from '../../services/config'

    export default {
        name: "Perfil",

        data(){
            return{
                perfil: {
                    id: null,
                    descricao: null,
                    pais: 'BRASIL',
                    estado: '0',
                    cidade: null,
                    codigo_cidade: '0',
                    versao_plano_contas: null,
                    index: null
                },
                usuarioPerfil: {
                    id: null,
                    perfil: null,
                    usuario: null,
                    index: null
                },
                perfilEmail: {
                    id: null,
                    perfil: null,
                    nome: null,
                    email: null,
                    tipo_envio_relatorio: '0',
                    index: null
                },
                perfilImagem: {
                    id: null,
                    perfil: null,
                    tipo_destino_imagem: '1',
                    imagem: null
                },
                perfis: [],
                usuarios: [],
                usuariosPerfil: [],
                perfilEmails: [],
                perfilImagens: [],
                versoesPlanosContas: [],
                estados: [],
                cidades: [],
                previous: null,
                next: null,
                page: null,
                numpages: null,
                isShowModal: false,
                mostraCompartilhamento: false,
                mostraEmails: false,
                mostraImages: false,
                perfilSelecionado: {
                    id: null,
                    descricao: null
                },
                arquivoImagem: null,
                showInfo: false,
                destinoImagemLabels: {
                  '1': 'Cabeçalho',
                  '2': 'Rodapé',
                  '3': 'Logomarca',
                  '4': 'Capa do Relatório'
                }
            }
        },

        methods: {
            add: function() {
                this.clearFields()
                this.isShowModal = true              
            },

            edit: function(index){
                if (!this.mostraCompartilhamento && !this.mostraEmails && !this.mostraImages) {
                    this.perfil.id = this.perfis[index].id
                    this.perfil.descricao = this.perfis[index].descricao
                    this.perfil.pais = this.perfis[index].pais
                    this.perfil.estado = this.perfis[index].estado
                    this.perfil.cidade = this.perfis[index].cidade
                    this.perfil.codigo_cidade = this.perfis[index].codigo_cidade
                    this.perfil.versao_plano_contas = this.perfis[index].versao_plano_contas

                    httpPublic.get('https://servicodados.ibge.gov.br/api/v1/localidades/distritos/'+this.perfis[index].codigo_cidade).then(response => {
                        this.perfil.cidade = response.data[0]
                    })

                    this.perfil.index = index
                    this.isShowModal = true
                    this.selectEstado()

                } else if (this.mostraCompartilhamento) {
                    this.usuarioPerfil.id = this.usuariosPerfil[index].id
                    this.usuarioPerfil.usuario = this.usuariosPerfil[index].usuario
                    this.usuarioPerfil.perfil = this.usuariosPerfil[index].perfil
                    this.usuarioPerfil.index = index
                    this.isShowModal = true            
                } else if (this.mostraEmails) {
                    this.perfilEmail.id = this.perfilEmails[index].id
                    this.perfilEmail.nome = this.perfilEmails[index].nome
                    this.perfilEmail.email = this.perfilEmails[index].email
                    this.perfilEmail.perfil = this.perfilSelecionado
                    this.perfilEmail.tipo_envio_relatorio = this.perfilEmails[index].tipo_envio_relatorio
                    this.perfilEmail.index = index
                    this.isShowModal = true            
                } else {
                    this.perfilImagem.id = this.perfilImagens[index].id
                    this.perfilImagem.tipo_destino_imagem = this.perfilImagens[index].tipo_destino_imagem
                    this.perfilImagem.imagem = http.defaults.baseURL.replace("/api/", "")+this.perfilImagens[index].imagem
                    this.perfilImagem.perfil = this.perfilSelecionado
                    this.perfilImagem.index = index
                    this.isShowModal = true      
                }
            },

            clearFields: function() {
                if (!this.mostraCompartilhamento && !this.mostraEmails && !this.mostraImages) {
                    this.perfil = { id: null,
                    descricao: null,
                    pais: 'BRASIL',
                    cidade: null,
                    codigo_cidade: '0',
                    versao_plano_contas: null,
                    estado: '0'}
                } else if (this.mostraCompartilhamento) {
                    this.usuarioPerfil = { id: null,
                    perfil: this.perfilSelecionado,
                    usuario: null }
                } else if (this.mostraImages) {
                    this.perfilImagem = { id: null,
                        tipo_destino_imagem: '1',
                        imagem: null,
                        perfil: this.perfilSelecionado }
                } else {
                    this.perfilEmail = { id: null,
                        nome: null,
                        email: null,
                        tipo_envio_relatorio: '0',
                        perfil: this.perfilSelecionado
                    }
                    this.arquivoImagem = null
                }
            },

            callCompartilhamento: function(perfil) {
                this.mostraCompartilhamento = true
                this.perfilSelecionado = perfil
                http.get('compartilharPerfis/listar', {params: {
                    idPerfil: this.perfilSelecionado.id
                }}).then(response => {
                    this.usuariosPerfil = response.data.results
                })

            },

            callEmails: function(perfil) {
                this.mostraEmails = true
                this.perfilSelecionado = perfil
                http.get('perfilEmails/listar', {params: {
                    idPerfil: this.perfilSelecionado.id
                }}).then(response => {
                    this.perfilEmails = response.data.results
                })
            },

            callImages: function(perfil) {
                this.mostraImages = true
                this.perfilSelecionado = perfil
                http.get('perfilImagens/listar', {params: {
                    idPerfil: this.perfilSelecionado.id
                }}).then(response => {
                    this.perfilImagens = response.data.results
                    for (let index = 0; index < this.perfilImagens.length; index++) {
                        this.perfilImagens[index].imagem = http.defaults.baseURL.replace("/api/", "")+this.perfilImagens[index].imagem;
                    }
                })
            },

            uploadImageFile: function(evt) {
                this.perfilImagem.imagem = evt.target.files[0]
                this.arquivoImagem = evt.target.files[0].name
            },   

            erase: function(index){
                if (window.confirm('Confirma exclusão?')) {

                    if (!this.mostraCompartilhamento && !this.mostraEmails && !this.mostraImages) {
                        http.delete('/perfis/excluir/'+this.perfis[index].id).then(response =>{
                                this.perfis.splice(index, 1)
                                if (response.status == 204) {
                                    alert('Registro excluído!')
                                }
                            }).catch(e => {
                                console.log(e);
                            })
                    } else if (this.mostraCompartilhamento) {
                        http.delete('/compartilharPerfis/excluir/'+this.usuariosPerfil[index].id).then(response =>{
                                this.usuariosPerfil.splice(index, 1)
                                if (response.status == 204) {
                                    alert('Registro excluído!')
                                }
                            }).catch(e => {
                                console.log(e);
                            })
                    } else if (this.mostraImages) {
                        http.delete('/perfilImagens/excluir/'+this.perfilImagens[index].id).then(response =>{
                                this.perfilImagens.splice(index, 1)
                                if (response.status == 204) {
                                    alert('Registro excluído!')
                                }
                            }).catch(e => {
                                console.log(e);
                            })
                    } else {
                        http.delete('/perfilEmails/excluir/'+this.perfilEmails[index].id).then(response =>{
                                this.perfilEmails.splice(index, 1)
                                if (response.status == 204) {
                                    alert('Registro excluído!')
                                }
                            }).catch(e => {
                                console.log(e);
                            })
                    }
                }
            },

            save: function(){
                var data

                if (!this.mostraCompartilhamento && !this.mostraEmails && !this.mostraImages) {
                    if (this.perfil.descricao == null) {
                        alert('Descrição do perfil não informada!')
                        return
                    }

                    data = {id: this.perfil.id,
                        descricao: this.perfil.descricao,
                        pais: this.perfil.pais,
                        estado: this.perfil.estado,
                        cidade: this.perfil.cidade.nome,
                        codigo_cidade: this.perfil.cidade.id,
                        versao_plano_contas: null,
                        usuario: this.$store.state.idUser
                    }

                    if (this.perfil.versao_plano_contas != null) {
                        data.versao_plano_contas = this.perfil.versao_plano_contas.id
                    }    

                    if (this.perfil.id == null) {
                        http.post('/perfis/adicionar', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.perfil.id = response.data.id
                                this.perfil.codigo_cidade = this.perfil.cidade.id
                                this.perfis.push(this.perfil)
                                this.showInfo = true
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            console.log(e);
                        })

                    } else {
                        http.put('/perfis/editar/'+this.perfil.id, data).then(response =>{
                            this.perfis[this.perfil.index].descricao = response.data.descricao
                            this.perfis[this.perfil.index].pais = response.data.pais
                            this.perfis[this.perfil.index].estado = response.data.estado
                            this.perfis[this.perfil.index].cidade = response.data.cidade
                            this.perfis[this.perfil.index].codigo_cidade = response.data.codigo_cidade
                            this.perfis[this.perfil.index].versao_plano_contas = this.perfil.versao_plano_contas
                        }).catch(e => {
                            console.log(e);
                        })
                    }

                } else if (this.mostraCompartilhamento) {
                    if (this.usuarioPerfil.usuario == null) {
                        alert('Usuário não informado!')
                        return
                    }

                    data = {id: this.usuarioPerfil.id,
                        perfil: this.usuarioPerfil.perfil.id,
                        usuario: this.usuarioPerfil.usuario.id
                    }

                    if (this.usuarioPerfil.id == null) {
                        http.post('/compartilharPerfis/adicionar', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.usuarioPerfil.id = response.data.id
                                this.usuariosPerfil.push(this.usuarioPerfil)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            console.log(e);
                        })

                    } else {
                        http.put('/compartilharPerfis/editar/'+this.usuarioPerfil.id, data).then(
                            this.usuariosPerfil[this.usuarioPerfil.index].usuario = this.usuarioPerfil.usuario
                        ).catch(e => {
                            console.log(e);
                        })
                    }

                    
                } else if (this.mostraImages) {
                    if (this.perfilImagem.tipo_destino_imagem == null) {
                        alert('Destino da imagem não selecionado!')
                        return
                    }

                    if (this.perfilImagem.imagem == null) {
                        alert('Imagem não selecionada!')
                        return
                    }

                    data = {id: this.perfilImagem.id,
                        perfil: this.perfilImagem.perfil.id,
                        tipo_destino_imagem: this.perfilImagem.tipo_destino_imagem,
                        imagem: this.perfilImagem.imagem}

                    let formData = new FormData()

                    formData.append('id', data.id)
                    formData.append('perfil', data.perfil)
                    formData.append('tipo_destino_imagem', data.tipo_destino_imagem)
                    formData.append('imagem', data.imagem)

                    if (this.perfilImagem.id == null) {
                        http.post('/perfilImagens/adicionar', formData, {
                            headers: {
                                    "Content-Type": "multipart/form-data",
                            }}).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.perfilImagem.id = response.data.id
                                this.perfilImagem.imagem = http.defaults.baseURL.replace("/api/", "")+response.data.imagem
                                this.perfilImagens.push(this.perfilImagem)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })

                    } else {
                        http.put('/perfilImagens/editar/'+this.perfilImagem.id, formData, {
                            headers: {
                                    "Content-Type": "multipart/form-data",
                            }}).then(response =>{
                            this.perfilImagens[this.perfilImagem.index].tipo_destino_imagem = response.data.tipo_destino_imagem
                            this.perfilImagens[this.perfilImagem.index].imagem = http.defaults.baseURL.replace("/api/", "")+response.data.imagem
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    }

                } else {
                    if (this.perfilEmail.nome == null) {
                        alert('Nome não informado!')
                        return
                    }

                    if (this.perfilEmail.email == null) {
                        alert('Email não informado!')
                        return
                    }

                    data = {id: this.perfilEmail.id,
                        perfil: this.perfilEmail.perfil.id,
                        nome: this.perfilEmail.nome,
                        email: this.perfilEmail.email,
                        tipo_envio_relatorio: this.perfilEmail.tipo_envio_relatorio
                    }

                    if (this.perfilEmail.id == null) {
                        http.post('/perfilEmails/adicionar', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.perfilEmail.id = response.data.id
                                this.perfilEmails.push(this.perfilEmail)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            console.log(e);
                        })

                    } else {
                        http.put('/perfilEmails/editar/'+this.perfilEmail.id, data).then(
                            this.perfilEmails[this.perfilEmail.index].nome = this.perfilEmail.nome
                        ).catch(e => {
                            console.log(e);
                        })
                    }
                }
            },

            selectEstado: function() {
                httpPublic.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados/'+this.perfil.estado+'/distritos').then(response => {
                    this.cidades = _.orderBy(response.data, ['nome'])
                })
            },

            nextPage: function(){
                if (this.page != this.numpages) {
                    http.get(this.next).then(response =>{
                        this.perfis = response.data.results
                        this.previous = response.data.previous
                        this.next = response.data.next
                        this.page = response.data.page
                        this.numpages = response.data.numpages
                    })
                }
            },
            previousPage: function(){
                if (this.page != 1 ) {
                    http.get(this.previous).then(response =>{
                        this.perfis = response.data.results
                        this.previous = response.data.previous
                        this.next = response.data.next
                        this.page = response.data.page
                        this.numpages = response.data.numpages
                    })
                }
            },
            filterRecords: function(){
            }
        },

        mounted: function() {
        },
        
        created: function() {
            http.get('perfis/listar').then(response =>{
                this.perfis = response.data.results
                if (this.perfis.length > 0) {
                    this.showInfo = true
                }
            })

            http.get('usuarios/listar').then(response =>{
                this.usuarios = response.data.results
            })

            httpPublic.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados').then(response =>{
                this.estados = _.orderBy(response.data, ['sigla'])
                
            })

            http.get('versoesPlanoContas/listar').then(response => {
                this.versoesPlanosContas = response.data.results
            })

        }

    }
</script>

<style scoped>
</style>